<template>
  <div>
      <b-card no-body>
          <b-card-body>
              <h4 class="heading-1 mb-4">
                  <span>CONTRATOS - Valor Total dos Contratos</span>
              </h4>
              <filtros
                    :fornecedores="fornecedores"
                    :responsaveis="responsaveis"
                    @filtroAtualizado="filtro = $event"
                    tiposFiltros="ia"
                    
              ></filtros>
          </b-card-body>
          <b-card-footer>
              <app-btn-voltar></app-btn-voltar>
              <b-button
                  variant="primary"
                  @click.stop="emitirRelatorio()"
                  class="ml-2"
              >
                  <span>
                      <i class="fa fa-file-o mr-2"></i>Emitir Relatório</span
                  >
              </b-button>
          </b-card-footer>
      </b-card>
  </div>
</template>

<script>
import Filtros from './Filtros';
import RelatoriosServicos from './RelatoriosServicos';

export default {
  components: {
      Filtros
  },

  data() {
      return {
          responsaveis: null,
          fornecedores: null,
          statusContrato: null,
          filtro: {
              contrato: null,
              responsavel: null,
              fornecedor: null,
              dataInicioDe: null,
              dataInicioAte: null,
              dataFimDe: null,
              dataFimAte: null,
              apenasAtivos: false
          }
      }
  },

  methods: {
      obterFiltrosOpcoes() {
          this.$store.dispatch('addRequest')
          RelatoriosServicos.obterFiltrosOpcoes('rf').then((response) => {
              if (response) {
                  if (response.success) {
                      this.responsaveis = response.data.Funcionarios
                      this.responsaveis.unshift({
                          codFuncionario: null,
                          nome: 'TODOS'
                      })
                      this.fornecedores = response.data.Fornecedores
                      this.fornecedores.unshift({
                          codFornecedor: null,
                          nome: 'TODOS'
                      })
                  } else {
                      this.$toast.error(
                          'Erro ao obter opções do filtro!',
                          'ERRO',
                          this.$toastConfig.error
                      )
                  }
              }
              this.$store.dispatch('removeRequest')
          })
      },
      emitirRelatorio() {
          this.$store.dispatch('addRequest')
          RelatoriosServicos.emitirRelatorio(
              'valortotalcontratos',
              this.filtro
          ).then((response) => {
              if (response) {
                  if (response.type === 'application/json') {
                      this.$toast.error(
                          'Erro ao emitir relatório!!!',
                          'ERROR',
                          this.$toastConfig.error
                      )
                  } else {
                      this.$download(
                          response,
                          'ValorTotalContratos.xlsx'
                      )
                  }
              }
              this.$store.dispatch('removeRequest')
          })
      }
  },

  mounted() {
      this.obterFiltrosOpcoes()
  },

  watch: {
      filtro() {}
  }
}
</script>
